



















import Vue from "vue";
import Component from "vue-class-component";
import reportStore from "@/store/reportsStore";
import { Observer } from "mobx-vue";
import LoadingPanel from "@/components/LoadingPanel.vue";
import ReportFilters from "@/components/Reports/ReportFilters.vue";
import ReportResults from "@/components/Reports/ReportResults.vue";
import { reaction } from "mobx";
import userStore from "@/store/userStore";
import collectionIssueEditStore from "@/store/collectionIssueEditStore";

@Observer
@Component({ components: { LoadingPanel, ReportFilters, ReportResults } })
class Reports extends Vue {
  dispose?: () => void;
  reportStore = reportStore;
  collectionIssueEditStore = collectionIssueEditStore;

  constructor() {
    super();
    this.reportStore.selectedResults = [];
    this.reportStore.fetchReports();
  }

  mounted() {
    this.dispose = reaction(
      () => userStore.councilConfiguration,
      () => {
        this.reportStore.fetchReports();
        const myFilters = this.$refs.filters as ReportFilters;
        myFilters.clearCache();
        collectionIssueEditStore.resetCollectionIssueEdit();
      }
    );
  }

  destroyed() {
    if (this.dispose) this.dispose();
  }
}

export default Reports;
